import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Input, Label, Progress, Row, Table } from 'reactstrap'
import ipoLimit from '../assets/images/ipoLimit.png'
import InfoPopup from './InfoPopup';
import BannerRibbon from './BannerRibbon';
import { ToastContainer, toast, } from 'react-toastify';
import { getIpoAmountInvest, getThirdPartyData, updateThirdPartyData, getUserNameFromPan, processUserAfterPan, dpValidation, setConsentApi, getUserPans } from '../services/waitlist-service';
import { setAnalyticsEvent } from '../../core/helpers/analytics';
import InfoTablePopUp from './infoTablePopUp';
import SubsSucess from './SubsSucess';
import UpiInfoTable from './UpiInfoTable';
import { color } from 'highcharts';
import limitExcede from '../assets/images/limitExcede.png'
import moment from 'moment';
import email from '../assets/images/email.png'
import OfflinePopUp from './OffilePopUp';
import UpiLimitPopup from './UpiLimitPopup';
import { utils } from '../../core/helpers/utils';

const FirstFoldIpo = (props) => {
    const [activeButton, setActiveButton] = useState('Monthly')
    const [marksView, setMarksView] = useState([true, false, false]);
    const [marksDone, setMarksDone] = useState(new Array(2).fill(false));
    const [showPopUpTextEligible, setShowIndicativeInfo] = useState(false);
    const [showPopUpTextMore, setShowPopUpTextMore] = useState(false)
    const [data, setData] = useState([]);
    const [popUpOverTextEligible, setPopUpOverTextEligible] = useState('');
    const [popUpOverText, setPopUpOverText] = useState('');
    const [inputValues, setInputValues] = useState({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [showTotalBids, setShowTotalBids] = useState(false);
    const [showDetailsScreen, setShowDetailsScreen] = useState(false)
    const [pan, setPan] = useState('');
    const [name, setName] = useState('');
    const [dematNo, setDematNo] = useState('');
    const [reEneterdematNo, setReEnterDematNo] = useState('');
    const [upiId, setUpiId] = useState('');
    const [errors, setErrors] = useState({});
    const [showSubsSuccess, setShowSubsSuccess] = useState(false);
    const [userDetails, setUserDetails] = useState();
    const [showThankYou, setShowThankYou] = useState(false);
    const [showUpiTable, setShowUpiTable] = useState(false)
    const [totalAmount, setTotalAmount] = useState(0);
    const [preBookText, setPreBookText] = useState(true);
    const [showUpiLimit, setShowUpiLimit] = useState(false);
    const [series, setSeries] = useState()
    const [buttonsLabel, setButtonsLabel] = useState()
    const [numSelectedByCouponType, setNumSelectedByCouponType] = useState();
    const [totalSelectedBids, setTotalSelectedBids] = useState()
    const [showEmailError, setShowEmailError] = useState(false)
    const [appNo, setAppNo] = useState()
    const [miniKyc, setMiniKyc] = useState(false)
    const [checked, setChecked] = useState(true)


    const handleButtonClick = (item) => {
        setActiveButton(item)
    }

    const calculateTotalAmount = () => {
        let sum = 0;
        selectedItems.forEach((item) => {
            if (inputValues[item.ISIN]) {
                sum += item.faceValue * inputValues[item.ISIN];
            }
        });
        return sum;
    };

    useEffect(() => {
        const newTotalAmount = calculateTotalAmount();
        setTotalAmount(newTotalAmount);
    }, [selectedItems, inputValues]);

    const handleInputChange = (item, newValue) => {
        const parsedValue = parseFloat(newValue);
            setInputValues((prevInputValues) => ({
                ...prevInputValues,
                [item.ISIN]: parsedValue,
            }));
    };

    const handleIncrease = (item) => {
        setInputValues((prevInputValues) => ({
            ...prevInputValues,
            [item.ISIN]: (prevInputValues[item.ISIN] || 0) + 1,
        }));
    };

    const handleDecrease = (item) => {
        const currentValue = inputValues[item.ISIN] || 0;
        if (currentValue > 0) {
            setInputValues((prevInputValues) => ({
                ...prevInputValues,
                [item.ISIN]: currentValue - 1,
            }));
        }
    };

    useEffect(()=>{
        if(series){
        const uniqueCouponTypes = new Set(series.map((button) => button.couponType));
        setButtonsLabel(uniqueCouponTypes)
        series.map((button) =>{ if(button.couponType === "Monthly"){
            const defaultInputValues = {};
                defaultInputValues[button.ISIN] = 10;
              setInputValues(defaultInputValues);
        }}
         )
        }
    },[series])
    
    useEffect(() => {
        setSeries(props?.ipoAssetDetails?.series)
        setData(props?.ipoAssetDetails?.series)
        const currentTime = moment();
        if (currentTime.day() === 0 || currentTime.day() === 6) {
             setPreBookText(true);
        }
        if (currentTime.isBefore(moment(props?.ipoAssetDetails?.openDate))) {
             setPreBookText(true);
        } else if (currentTime.isAfter(moment(props?.ipoAssetDetails?.openDate))) {
            // check market hours
            if (currentTime.isBefore(moment(props?.ipoAssetDetails?.marketStartTime, "HH:mm")) ||
                currentTime.isAfter(moment(props?.ipoAssetDetails?.marketEndTime, "HH:mm"))) {
                /** 
                 * outside market hours order to set as prebook.
                 * there is a script to fetch all ipo-prebooks orders and
                 * place them on the exchange
                */
                setPreBookText(true);
            } else {
                 setPreBookText(false);
            }
        }

        let closeDateTime = moment(props?.ipoAssetDetails?.closeDate).format("DD/MM/YYYY");
        closeDateTime += `${props?.ipoAssetDetails?.marketEndTime}`;
        closeDateTime = moment(closeDateTime, "DD/MM/YYYYhh:mm");
        
        if (currentTime.isAfter(closeDateTime)) {
             console.log(props?.cancelBidHandle())
        }
    }, [props])

    const toggleThankYou = () => {
        setShowThankYou(!showThankYou);
        window.location.reload()
    };

    const toggleUpiLimitPopup = () => {
        setShowUpiLimit(!showUpiLimit);
    }

    const clickNext = (issuer) => {
        {
            process.env.REACT_APP_RENDER_GA === "true" &&
            setAnalyticsEvent("SIncd_seriesSelect_" + issuer);
        }
        getUserPans({ "X-product": `orobonds:default` }).then((result) => {
            const response = utils.parsePayload(result);

            if (response && response.success) {
                if (!response.data || !response.data.length) {
                    setMiniKyc(true)
                }
            }
        })
        if ((totalAmount) > 500000 && (totalAmount) <= 1000000) {
            toggleUpiLimitPopup();
        } if ((totalAmount) <= 500000) {
            getThirdPartyData({ "X-product": `orobonds:default}`, 'x-encrypted-data': true }).then(
                (result) => {
                    const res = utils.parsePayload(result);

                    if (res && res.success) {
                        setUserDetails(res.data)
                    }
                })
            let mark = [...marksView]
            mark[1] = true
            setMarksView(mark)
            setShowDetailsScreen(true)
        } if ((totalAmount) > 1000000) {
            
            setShowPopUpTextMore(!showPopUpTextMore)
            setPopUpOverText(`<p className="title text-center text-primary">Online Application Amount Exceeded!!</p> <p className="text-center">Maximum application amount for online application is 10L.</p> <p className="text-center">Go back and revise your bid amount to apply online through UPI.</p><p className="text-center">Still wish to proceed? Apply through offline process</p>`)
        }
    }

    const handleProceedOffline = () => {
        let mark = [...marksView]
            mark[1] = true
            setMarksView(mark)
            setShowDetailsScreen(true)
            getThirdPartyData({ "X-product": `orobonds:default}`, 'x-encrypted-data': true }).then(
                (result) => {
                    const res = utils.parsePayload(result);
                    
                    if (res && res.success) {
                        setUserDetails(res.data)
                        {
                            process.env.REACT_APP_RENDER_GA === "true" &&
                            setAnalyticsEvent("SIncd_bidOffline_" + props?.ipoAssetDetails?.issuer);
                        }
                    }
                })
    }

    const handleSubmit = (e) => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        e.preventDefault();
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        const newErrors = {};

        const upiRegex = /^[a-zA-Z0-9.\-_]{2,}@[a-zA-Z]{3,}$/;
        if (!upiRegex.test(upiId)) {
            newErrors.upiId = "Please enter a valid UPI ID.";
        } else {
            const inputParts = upiId.split('@');

            if (totalAmount <= 1000000) {
                if (inputParts.length > 1) {
                    const handle = inputParts[1].toLowerCase();

                    // Check if the handle is among supported UPI handles
                    const matchingHandle = props?.staticContent?.ipo.IPO_UPI_HANDLES.find(
                        (item) => item.handle.split("@")[1].toLowerCase() === handle
                    );

                    if (!matchingHandle) {
                        newErrors.upiId = "Please use the supported UPI handle as seen in the list below.";
                    }
                } else {
                    newErrors.upiId = "Please enter a valid UPI ID.";
                }
            }
        }

        // if (totalAmount <= 1000000) {
        //     if (inputParts.length > 1) {
        //         handle = inputParts[1].toLowerCase();
        //         matchingHandle = props?.staticContent?.ipo.IPO_UPI_HANDLES.find(
        //             (item) => item.handle.split("@")[1].toLowerCase() === handle
        //         );
        //         if (!matchingHandle) {
        //             newErrors.upiId = "Please use the supported UPI handle as seen in the list below.";
        //         }
        //     } else {
        //         newErrors.upiId = "Please enter a valid UPI ID.";
        //     }
        // }

        if (!userDetails?.pan && !pan.trim()) {
            newErrors.pan = 'PAN No is required.';
        }
        if (!userDetails?.name && !name.trim()) {
            newErrors.name = 'Full Name is required.';
        }
        if (!userDetails?.demat && !dematNo.trim()) {
            newErrors.dematNo = 'Demat Number is required.';
        }
        if (!upiId.trim() && totalAmount < 1000000) {
            newErrors.upiId = 'Enter UPI Id';
        }
        if (!userDetails?.demat && !reEneterdematNo.trim()) {
            newErrors.reEneterdematNo = 'Demat Number is required.';
        }
        if (dematNo !== reEneterdematNo) {
            newErrors.reEneterdematNo = 'Demat Number does not match.';
        }if(dematNo.length < 16 && !userDetails?.demat){
            newErrors.dematNo = 'Please Enter Valid Demat Number';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        if (!userDetails?.pan) {
            getUserNameFromPan(pan, { "X-product": `orobonds:default` })
                .then((response) => {
                    if (!response || !response.success) {
                        return toast.error(
                            response.message || "something went wrong"
                        );
                    } if(!userDetails.demat) {
                        validateDemate()
                    }else if (response && response.success) {
                        getUserPan()
                        setShowSubsSuccess(!showSubsSuccess)
                        let mark = [...marksView]
                        mark[2] = true
                        setMarksView(mark)
                        setShowDetailsScreen(false)
                    }
                })
        }else if(!userDetails.demat){
            validateDemate()
        }else{
            setShowSubsSuccess(!showSubsSuccess)
            let mark = [...marksView]
            mark[2] = true
            setMarksView(mark)
            setShowDetailsScreen(false)
        }
    };

    useEffect(()=>{
        if (!userDetails?.pan && showEmailError) {
            getUserNameFromPan(pan, { "X-product": `orobonds:default` })
                .then((response) => {
                    if (!response || !response.success) {
                        return toast.error(
                            response.message || "something went wrong"
                        );
                    }else if (response && response.success) {
                        // getUserPan()
                       setName(response.data.full_name)
                    }
                })
        }
    },[showEmailError])

    const getUserPan = () => {
        const payloadData = utils.encryptedPayload({
            pan: userDetails?.pan ? userDetails?.pan : pan,
            demat: userDetails?.demat ? userDetails?.demat : dematNo,
            name: name.length > 1 ? name : userDetails?.name && userDetails?.name.length > 1 ? userDetails?.name : name,
            upi: upiId,
            productName: 'oroBonds',
        });
        if (!userDetails.pan || !userDetails.demat || miniKyc) {
            updateThirdPartyData(payloadData, { "X-product": `orobonds:default`, 'x-encrypted-data': true })
                .then((result) => {
                    const resp = utils.parsePayload(result);
                    if (!resp || !resp.success) {
                        toast.error(resp.msg || "something went wrong: thirdParty");
                    } else {
                        processUserAfterPan({ "X-product": `orobonds:default` })
                            .then((response) => {
                                if (!response || !response.success || !response.data) {
                                    return toast.err(response.message || "something went wrong: thirdParty")
                                }
                            });
                        {   process.env.REACT_APP_RENDER_GA === "true" &&
                            setAnalyticsEvent(window.location.pathname + window.location.hash,
                                "Demat_Verified"
                            );
                        }
                        {
                            process.env.REACT_APP_RENDER_GA === "true" &&
                            setAnalyticsEvent("SIncd_detailsEntered_" + props?.ipoAssetDetails?.issuer);
                        }
                    }
                });
        }
    };

    useEffect(() => {
        const updatedData = data.map((item) =>
            inputValues[item.ISIN] >= 1 ? { ...item, selected: true } : { ...item, selected: false }
        );
        setData(updatedData);
        const selectedItemsArray = updatedData.filter((item) => item.selected);
        setSelectedItems(selectedItemsArray);
    }, [inputValues]);

    const handleShowTable = () => {
        setShowTotalBids(!showTotalBids)
    }

    const handleShowUpiList = () => {
        setShowUpiTable(!showUpiTable)
    }

    const handleSubsSucess = () => {
        let headers2 = {
            "X-product": `orobonds:${props.ipoAssetDetails.product}`
          };
          let payload2 = {
            type: "ipoTransaction",
            consent: true,
          };
          setConsentApi(payload2, headers2)
            .then((result) => {
                const response = utils.parsePayload(result);
              if (response && response.successs) {
               console.log("Success");
              }
            });
        let payload
        if (upiId) {
            payload = {
                "ISIN": props?.ipoAssetDetails?.ISIN,
                "upiId": upiId,
                "series": selectedItems.map((item) => ({
                    "ISIN": item.ISIN,
                    "units": inputValues[item.ISIN]
                }))
            };
        } else {
            payload = {
                "ISIN": props?.ipoAssetDetails?.ISIN,
                "series": selectedItems.map((item) => ({
                    "ISIN": item.ISIN,
                    "units": inputValues[item.ISIN]
                }))
            };
        }
        if (payload) {
            getIpoAmountInvest({ "X-product": `orobonds:${props.ipoAssetDetails.product}` }, payload).then(
                (res) => {
                    if (res.success) {
                        setAppNo(res.data[0].series[0].applicationNo)
                        var series
                        res.data.filter((item)=> series = item.series)
                        if(series[0].status === "pending" || series[0].status === "created" || series[0].status === "prebook"){
                            {
                            setShowThankYou(!showThankYou)
                            { process.env.REACT_APP_RENDER_GA === "true" &&
                                setAnalyticsEvent("SIncd_bidConfirmed_" + props?.ipoAssetDetails?.issuer);
                            }
                            }
                        }else{
                            toast.error("Bid failed")
                        } 
                    //    series.filter((ser)=> (ser.bidStatus.success == false && toast.error(ser.bidStatus.message)))
                    } if (!res.success) {
                        toast.error(res.message);
                    }
                },
                (err) => {
                    toast.error("err", err);
                }
            );
        }
    }

    const validateDemate = () =>{
        let demat = dematNo.substr(0, 8);
        dpValidation(demat, {"X-product": `orobonds:default`}).then(
            (result) => {
            const dpResp = utils.parsePayload(result);
              if (dpResp && dpResp.success) {
                let headers = {
                  "X-product": `orobonds:default`
                };
                let payload = {
                  type: "obTransaction",
                  consent: true,
                };
                setConsentApi(payload, headers)
                  .then(result => {
                    const response = utils.parsePayload(result);
                    if (response && response.successs) {
                        setShowSubsSuccess(!showSubsSuccess)
                        let mark = [...marksView]
                        mark[2] = true
                        setMarksView(mark)
                        setShowDetailsScreen(false)
                        getUserPan()
                    }
                  })
              } else {
                toast.error("Invalid demat number");
              }
            }
          )
    }

    const handleBackClick = () => {
        if (showDetailsScreen) {
            setShowDetailsScreen(false)
            let mark = [...marksView]
            mark[1] = false
            setMarksView(mark)
        }
        if (showSubsSuccess) {
            setShowSubsSuccess(false)
            setShowDetailsScreen(true)
            let mark = [...marksView]
            mark[1] = true
            mark[2] = false
            setMarksView(mark)
        }
    }

    function calculateNumSelectedByCouponType(selectedItems) {
        const numSelectedByCouponType = {};
        selectedItems.forEach((item) => {
          const { couponType } = item;
          if (numSelectedByCouponType[couponType]) {
            numSelectedByCouponType[couponType]++;
          } else {
            numSelectedByCouponType[couponType] = 1;
          }
        });
        return numSelectedByCouponType;
    }

    function calculateTotalSeriesSelectedByCouponType(series, couponType) {
        let totalSeriesSelected =  selectedItems.filter((item) => item.couponType === couponType).length;
        return totalSeriesSelected;
    }

    useEffect(() => {
        const newTotalAmount = calculateTotalAmount(selectedItems, inputValues);
    setTotalAmount(newTotalAmount);
    
    const newNumSelectedByCouponType = calculateNumSelectedByCouponType(selectedItems);
        setNumSelectedByCouponType(newNumSelectedByCouponType);
        const newTotalSelectedBids = selectedItems.length;
        setTotalSelectedBids(newTotalSelectedBids);
    }, [selectedItems, inputValues]);
 
    return (
        <>
            {props.isMobile ? <div className='wrap'>
                <p className='title mb-1'>
                    {props?.ipoAssetDetails?.productName}
                </p>
                <p className='subtext mb-0'>
                    {props.ipoAssetDetails &&
                        props.ipoAssetDetails.tagLine}
                </p>
            </div> : null}
            <Row className='ipo-first-fold'>
                <Col lg={5} className={props.ipoAssetDetails.category !== "historical" ? 'col-first' : 'col-first text-center mr-auto ml-auto'}>
                    <div className="col-first__wrapper">
                        {
                            props?.isMobile ? 
                            <div className="d-flex wrap mr-auto ml-0">
                                <span class="mdi mdi-checkbox-blank-circle small-circle"></span>
                                <p className="mb-0">NCD IPO</p>
                            </div> : null
                        }
                        <p className='title mb-1'>
                            {props?.ipoAssetDetails?.productName}
                        </p>
                        <p className='subtext'>
                            {props.ipoAssetDetails &&
                                props.ipoAssetDetails.tagLine}
                        </p>
                        <div className='ribbon-main'>
                            {props?.ipoAssetDetails && props?.ipoAssetDetails.highlights &&
                                props?.ipoAssetDetails.highlights.length ?
                                props?.ipoAssetDetails.highlights.map(item => (
                                    <BannerRibbon text={item.web} popup={item.popup} />
                                )) : null}
                        </div>
                        {props.issueList && props.issueList.length && <div className='points'>
                            {props.issueList?.map((item, key) => (
                                <div className='cards'>
                                    <p className='first-text text-muted'>{item.point}
                                    </p>
                                    <p
                                        className='second-text'
                                        dangerouslySetInnerHTML={{ __html: item.explaination }}
                                    />
                                </div>
                            ))}
                        </div>}
                    </div>
                </Col>

               {props.ipoAssetDetails.category !== "historical" ? 
               <Col lg={7} className='col-second'>
                    <div className='calc-div w-100'>
                        <div className="mark-main-2">
                            <div className="marks">
                                <img alt=''/>
                                {marksView[0] && (
                                    <div className="mdi-holder">
                                        <span>1</span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={props?.isMobile ? "55" : "122"}
                                            height={props?.isMobile ? "15" : "6"}
                                            viewBox="0 0 122 6"
                                            fill="none"
                                        >
                                            <path
                                                d="M122 3L117 0.113249V5.88675L122 3ZM0 3.5H1.01667V2.5H0V3.5ZM3.05 3.5H5.08333V2.5H3.05V3.5ZM7.11667 3.5H9.15V2.5H7.11667V3.5ZM11.1833 3.5H13.2167V2.5H11.1833V3.5ZM15.25 3.5H17.2833V2.5H15.25V3.5ZM19.3167 3.5H21.35V2.5H19.3167V3.5ZM23.3833 3.5H25.4167V2.5H23.3833V3.5ZM27.45 3.5H29.4833V2.5H27.45V3.5ZM31.5167 3.5H33.55V2.5H31.5167V3.5ZM35.5833 3.5H37.6167V2.5H35.5833V3.5ZM39.65 3.5H41.6833V2.5H39.65V3.5ZM43.7167 3.5H45.75V2.5H43.7167V3.5ZM47.7833 3.5H49.8167V2.5H47.7833V3.5ZM51.85 3.5H53.8833V2.5H51.85V3.5ZM55.9167 3.5H57.95V2.5H55.9167V3.5ZM59.9833 3.5H62.0167V2.5H59.9833V3.5ZM64.05 3.5H66.0833V2.5H64.05V3.5ZM68.1167 3.5H70.15V2.5H68.1167V3.5ZM72.1833 3.5H74.2167V2.5H72.1833V3.5ZM76.25 3.5H78.2833V2.5H76.25V3.5ZM80.3167 3.5H82.35V2.5H80.3167V3.5ZM84.3833 3.5H86.4167V2.5H84.3833V3.5ZM88.45 3.5H90.4833V2.5H88.45V3.5ZM92.5166 3.5H94.55V2.5H92.5166V3.5ZM96.5833 3.5H98.6166V2.5H96.5833V3.5ZM100.65 3.5H102.683V2.5H100.65V3.5ZM104.717 3.5H106.75V2.5H104.717V3.5ZM108.783 3.5H110.817V2.5H108.783V3.5ZM112.85 3.5H114.883V2.5H112.85V3.5ZM116.917 3.5H118.95V2.5H116.917V3.5Z"
                                                fill="#CDCBCB"
                                            />
                                        </svg>
                                    </div>
                                )}
                                {marksDone[0] && <div className="mdi-holder"></div>}
                                {!marksView[0] && !marksDone[0] && <div className="rounded" />}
                                <div className="text">Select Series</div>
                            </div>
                            <div className="marks">
                                <img alt=''/>
                                {marksView[1] && (
                                    <div className="mdi-holder">
                                        <span>2</span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={props?.isMobile ? "55" : "122"}
                                            height={props?.isMobile ? "15" : "6"}
                                            viewBox="0 0 122 6"
                                            fill="none"
                                        >
                                            <path
                                                d="M122 3L117 0.113249V5.88675L122 3ZM0 3.5H1.01667V2.5H0V3.5ZM3.05 3.5H5.08333V2.5H3.05V3.5ZM7.11667 3.5H9.15V2.5H7.11667V3.5ZM11.1833 3.5H13.2167V2.5H11.1833V3.5ZM15.25 3.5H17.2833V2.5H15.25V3.5ZM19.3167 3.5H21.35V2.5H19.3167V3.5ZM23.3833 3.5H25.4167V2.5H23.3833V3.5ZM27.45 3.5H29.4833V2.5H27.45V3.5ZM31.5167 3.5H33.55V2.5H31.5167V3.5ZM35.5833 3.5H37.6167V2.5H35.5833V3.5ZM39.65 3.5H41.6833V2.5H39.65V3.5ZM43.7167 3.5H45.75V2.5H43.7167V3.5ZM47.7833 3.5H49.8167V2.5H47.7833V3.5ZM51.85 3.5H53.8833V2.5H51.85V3.5ZM55.9167 3.5H57.95V2.5H55.9167V3.5ZM59.9833 3.5H62.0167V2.5H59.9833V3.5ZM64.05 3.5H66.0833V2.5H64.05V3.5ZM68.1167 3.5H70.15V2.5H68.1167V3.5ZM72.1833 3.5H74.2167V2.5H72.1833V3.5ZM76.25 3.5H78.2833V2.5H76.25V3.5ZM80.3167 3.5H82.35V2.5H80.3167V3.5ZM84.3833 3.5H86.4167V2.5H84.3833V3.5ZM88.45 3.5H90.4833V2.5H88.45V3.5ZM92.5166 3.5H94.55V2.5H92.5166V3.5ZM96.5833 3.5H98.6166V2.5H96.5833V3.5ZM100.65 3.5H102.683V2.5H100.65V3.5ZM104.717 3.5H106.75V2.5H104.717V3.5ZM108.783 3.5H110.817V2.5H108.783V3.5ZM112.85 3.5H114.883V2.5H112.85V3.5ZM116.917 3.5H118.95V2.5H116.917V3.5Z"
                                                fill="#CDCBCB"
                                            />
                                        </svg>
                                    </div>
                                )}
                                {marksDone[1] && <div className="mdi-holder"></div>}
                                {!marksView[1] && !marksDone[1] && (
                                    <div className="mdi-holder">
                                        <span className="rounded"></span>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={props?.isMobile ? "55" : "122"}
                                            height={props?.isMobile ? "15" : "6"}
                                            viewBox="0 0 122 6"
                                            fill="none"
                                        >
                                            <path
                                                d="M122 3L117 0.113249V5.88675L122 3ZM0 3.5H1.01667V2.5H0V3.5ZM3.05 3.5H5.08333V2.5H3.05V3.5ZM7.11667 3.5H9.15V2.5H7.11667V3.5ZM11.1833 3.5H13.2167V2.5H11.1833V3.5ZM15.25 3.5H17.2833V2.5H15.25V3.5ZM19.3167 3.5H21.35V2.5H19.3167V3.5ZM23.3833 3.5H25.4167V2.5H23.3833V3.5ZM27.45 3.5H29.4833V2.5H27.45V3.5ZM31.5167 3.5H33.55V2.5H31.5167V3.5ZM35.5833 3.5H37.6167V2.5H35.5833V3.5ZM39.65 3.5H41.6833V2.5H39.65V3.5ZM43.7167 3.5H45.75V2.5H43.7167V3.5ZM47.7833 3.5H49.8167V2.5H47.7833V3.5ZM51.85 3.5H53.8833V2.5H51.85V3.5ZM55.9167 3.5H57.95V2.5H55.9167V3.5ZM59.9833 3.5H62.0167V2.5H59.9833V3.5ZM64.05 3.5H66.0833V2.5H64.05V3.5ZM68.1167 3.5H70.15V2.5H68.1167V3.5ZM72.1833 3.5H74.2167V2.5H72.1833V3.5ZM76.25 3.5H78.2833V2.5H76.25V3.5ZM80.3167 3.5H82.35V2.5H80.3167V3.5ZM84.3833 3.5H86.4167V2.5H84.3833V3.5ZM88.45 3.5H90.4833V2.5H88.45V3.5ZM92.5166 3.5H94.55V2.5H92.5166V3.5ZM96.5833 3.5H98.6166V2.5H96.5833V3.5ZM100.65 3.5H102.683V2.5H100.65V3.5ZM104.717 3.5H106.75V2.5H104.717V3.5ZM108.783 3.5H110.817V2.5H108.783V3.5ZM112.85 3.5H114.883V2.5H112.85V3.5ZM116.917 3.5H118.95V2.5H116.917V3.5Z"
                                                fill="#CDCBCB"
                                            />
                                        </svg>
                                    </div>
                                )}
                                <div className="text">Enter Details</div>
                            </div>
                            <div className="marks">
                                <img alt=''/>
                                {marksView[2] && (
                                    <div className="mdi-holder">
                                        <span>3</span>
                                    </div>
                                )}
                                {marksDone[2] && <div className="mdi-holder"></div>}
                                {!marksView[2] && !marksDone[2] && (
                                    <div className="mdi-holder">
                                        <span className="rounded"></span>
                                    </div>
                                )}
                                <div className="text">Confirm</div>
                            </div>
                        </div>
                        <div className='w-100 title-div '>
                            {(!showDetailsScreen && !showSubsSuccess) ? <p
                                className={
                                    "text-center font-weight-semi-bold mb-0 " +
                                    (!props.isMobile ? "navi-font-26 text-center" : "navi-font-18 text-center")
                                }
                            >
                                {showSubsSuccess ? "Confirm Bids" : "Choose Interest Payout Options"}
                            </p> :
                                <> 
                                    <div className='w-100 d-flex justify-content-start'>
                                        <div className='back-btn ml-2'>
                                            <p onClick={() => handleBackClick()} className="back-button mb-0">
                                                <span class="mdi mdi-arrow-left-thick"></span>
                                            </p>
                                        </div>
                                        <p
                                            className={
                                                "text-center font-weight-semi-bold ml-auto mr-auto " +
                                                (!props.isMobile ? "navi-font-28 text-center" : "navi-font-24 text-center")
                                            }
                                        >
                                            {showSubsSuccess ? 'Confirm Bids' : 'Enter Details'}
                                        </p>
                                    </div>
                                </>
                            }
                        </div>
                        {(!showDetailsScreen && !showSubsSuccess && buttonsLabel) && (
                            <div className='price-div'>
                                {Array.from(buttonsLabel).map((couponType) => {
                                    const totalSeriesSelected = calculateTotalSeriesSelectedByCouponType(series, couponType);

                                    return (
                                        <Button
                                            key={couponType}
                                            outline
                                            className={`btn-margin ${activeButton === couponType ? "btnclr" : "btnclrnotselected"}`}
                                            onClick={() => handleButtonClick(couponType)}
                                        >
                                            {couponType} <span className="circle">{totalSeriesSelected || "0"}</span>
                                        </Button>
                                    );
                                })}
                            </div>
                        )}


                        {!showDetailsScreen && 
                        <div className="table-wrapper">
                            <Table className="custom-table" style={props?.isMobile ? {width: "max-content"} : {width: "97%"}}>
                                <tr>
                                {showSubsSuccess ? 
                                    <th className='t-head' style={{minWidth: "10%"}}>Interest Payout</th> : <th className='t-head'>Series</th>}
                                    <th className='t-head' style={{minWidth: "15%"}}>Yield</th>
                                    <th className='t-head' style={{minWidth: "10%"}}>Tenure <br/>(Months)</th>
                                    <th className='t-head' style={{minWidth: "20%"}}>Principal <br/>Repayment </th>
                                    <th className='t-head' style={{minWidth: "25%"}}>Units</th>
                                    <th className='t-head' style={{minWidth: "20%"}}>Bid <br/>Amount</th>
                                </tr>
                                {!showSubsSuccess ? <>
                                        {series &&
                                        series.filter((tableData) => (
                                                tableData.isActive && activeButton === tableData.couponType
                                            )).sort((a, b) => {
                                                const aProductName = parseFloat(a.productName);
                                                const bProductName = parseFloat(b.productName);
                                                return aProductName - bProductName;
                                            }).map((tableData) => (
                                            tableData.isActive && activeButton === tableData.couponType && (
                                                <tr
                                                    className={inputValues[tableData.ISIN] >= 1 ? 'checked text-center' : 'text-center not-checked'}
                                                    key={tableData.ISIN}
                                                >
                                                    <td className='series-data' style={{minWidth: "10%"}}>{tableData.productName}</td>
                                                    <td className='series-data' style={{minWidth: "15%"}}>{tableData.xirr}%</td>
                                                    <td className='series-data' style={{minWidth: "10%"}}>{tableData.maxTenure}</td>
                                                    <td className='series-data' style={{minWidth: "20%"}}>{tableData.principalRepayment}</td>
                                                    <td className='series-data' style={{minWidth: "25%"}}>
                                                        <div className='justify-content-center d-flex'>
                                                            <span className="mdi mdi-minus arrow" onClick={() => handleDecrease(tableData)}></span>
                                                            <Input
                                                                inputMode='numeric'
                                                                pattern='[0-9]*'
                                                                value={inputValues[tableData.ISIN] || '0'}
                                                                onChange={(e) => handleInputChange(tableData, e.target.value)}
                                                                className='input-field'
                                                            />
                                                            <span className="mdi mdi-plus arrow" onClick={() => handleIncrease(tableData)}></span>
                                                        </div>
                                                    </td>
                                                    <td className='series-data' style={{minWidth: "20%"}}>{inputValues[tableData.ISIN] ? (tableData.faceValue * inputValues[tableData.ISIN]).oroNumber(2, true) : "₹0"}</td>
                                                </tr>
                                            )
                                        ))}

                                    </> :
                                    <>
                                        {showSubsSuccess && selectedItems.map((item) =>
                                            <tr className='checked text-center' key={item.ISIN}>
                                                <td className='series-data1' style={{minWidth: "10%"}}>{item.couponType}</td>
                                                <td className='series-data1' style={{minWidth: "15%"}}>
                                                    {item.xirr}%
                                                </td>
                                                <td className='series-data1' style={{minWidth: "10%"}}>
                                                    {item.maxTenure}
                                                </td>
                                                <td className='series-data1' style={{minWidth: "20%"}}>
                                                    {item.principalRepayment}
                                                </td>
                                                <td className='series-data1' style={{minWidth: "25%"}}>
                                                    {inputValues[item.ISIN]}
                                                </td>
                                                <td className='series-data1' style={{minWidth: "20%"}}>{inputValues[item.ISIN] ? (item.faceValue * inputValues[item.ISIN]).oroNumber(2, true) : "₹0"}</td>
                                            </tr>
                                        )
                                        }
                                    </>
                                }
                            </Table>
                        </div>
                        }

                        {(!showDetailsScreen && !showSubsSuccess) && (
                            <div className='inv-div'>
                                <div style={{}}>
                                    <p className='mb-0 total-bid amount-div text-left'>Total Bid Amount</p>
                                    <span
                                        className="text-primary"
                                        onClick={() => handleShowTable()}
                                    >
                                        <p className='selected-bids hover-details font-size-14'>
                                            <u>Total Selected Bids: {totalSelectedBids}</u>
                                        </p>
                                    </span>
                                </div>
                                <div style={{}}>
                                    <p className='mb-0 total-bid text-right'>
                                        {totalAmount ? (totalAmount).oroNumber(2, true) : "₹0"}
                                    </p>
                                    {totalAmount < 10000 && <p className="red-statement">Minimum Bid Amount should be ₹10,000</p>}
                                </div>
                            </div>
                        )}

                        {showDetailsScreen &&
                            <>
                                <Form onSubmit={handleSubmit}>
                                    <div className="mb-3 justify-content-between">
                                        <Label htmlFor="pType3" className="details-label">
                                            Pan Number
                                        </Label>
                                        <Input
                                            type="text"
                                            name="PAN"
                                            value={userDetails?.pan ? userDetails?.pan : pan}
                                            disabled={userDetails?.pan ? true : false}
                                            maxLength={10}
                                            placeholder={userDetails?.pan ? userDetails.pan : "PAN No*"}
                                            onChange={(e) => setPan(e.target.value)}
                                            className='details-input'
                                            onBlur={e => setShowEmailError(!showEmailError)}
                                        />
                                        {errors.pan && <p className="text-danger mx-3">{errors.pan}</p>}
                                    </div>
                                    <div className="mb-3 justify-content-between">
                                        <Label htmlFor="pType3" className="details-label">
                                            Full Name
                                        </Label>
                                        <Input
                                            type="text"
                                            name="name"
                                            disabled={userDetails?.name && userDetails.name.length > 1 ? true : false}
                                            value={name ? name : userDetails?.name && userDetails.name.length > 1 ? userDetails?.name : name}
                                            placeholder={ name ? name : userDetails?.name && userDetails.name.length > 1 ? userDetails?.name : "Full Name"}
                                            onChange={(e) => setName(e.target.value)}
                                            className='details-input'
                                        />
                                        {errors.name && <p className="text-danger mx-3">{errors.name}</p>}
                                    </div>
                                    <div className="mb-3 justify-content-between">
                                        <Label htmlFor="pType3" className="details-label">
                                            Demat Number
                                        </Label>
                                        <Input
                                            type="password"
                                            name="dematNo"
                                            value={userDetails?.demat ? userDetails?.demat : dematNo}
                                            disabled={userDetails?.demat ? true : false}
                                            placeholder={userDetails?.demat ? userDetails?.demat : "Enter Demat Number*"}
                                            onChange={(e) => setDematNo(e.target.value)}
                                            className='details-input'
                                        />
                                        {errors.dematNo && <p className="text-danger mx-3">{errors.dematNo}</p>}
                                    </div>
                                    <div className="mb-3 justify-content-between">
                                        <Label htmlFor="pType3" className="details-label">
                                            Re-enter Demat Number
                                        </Label>
                                        <Input
                                            type="text"
                                            name="reEneterdematNo"
                                            onPaste={(e) => {
                                                e.preventDefault();
                                                return false;
                                              }}
                                            value={userDetails?.demat ? userDetails?.demat : reEneterdematNo}
                                            disabled={userDetails?.demat ? true : false}
                                            placeholder={userDetails?.demat ? userDetails?.demat : "Enter Demat Number*"}
                                            onChange={(e) => setReEnterDematNo(e.target.value)}
                                            className='details-input'
                                        />
                                        {errors.reEneterdematNo && <p className="text-danger mx-3">{errors.reEneterdematNo}</p>}
                                    </div>
                                    {totalAmount < 1000000 && <div className="mb-3 justify-content-between">
                                        <Label htmlFor="pType3" className="details-label">
                                            UPI ID
                                        </Label>
                                        <Input
                                            type="text"
                                            name="upiId"
                                            placeholder="example@upi"
                                            className='details-input'
                                            onChange={(e) => setUpiId(e.target.value)}
                                        />
                                        {errors.upiId && <p className="text-danger mx-3">{errors.upiId}</p>}
                                        <p className="mt-2 mb-4 mx-3 justify-content-between"><u className='hover-details' onClick={() => handleShowUpiList()}>See the list of supported UPI Handles</u></p>
                                    </div>}


                                    <Button className='m-auto btn1' type="submit">Next</Button>
                                </Form>
                            </>
                        }
                        {(!showDetailsScreen && !showSubsSuccess) && <div className="btn-next">
                            <Button className='m-auto btn1'
                                disabled={totalAmount < 10000 || selectedItems.length < 1 ? true : false || !props?.ipoAssetDetails?.isTxnAllowed}
                                onClick={() => clickNext(props?.ipoAssetDetails.issuer)}
                            >
                                Next
                            </Button>
                        </div>
                        }
                        {
                            showSubsSuccess &&
                            <div className="btn-next">
                                <p className={"footer text-center mb-5"}>
                                        <input type="checkbox"
                                            defaultChecked={checked}
                                            onChange={() => setChecked(!checked)}
                                        />&nbsp;
                                        By proceeding, I accept the &nbsp;
                                        <a className="text-secondary" target="_blank" href={process.env.REACT_APP_URL_ENDPOINTS + "/terms-of-use/"}><b>Terms, Conditions & Disclaimer</b> </a> and have read the
                                        &nbsp;<a className="text-secondary" target="_blank" href="https://marketing.biddeasy.com/Assets/webAssets/IFS/NCDProspectusIFS.pdf"><b>Prospectus</b></a>
                                    </p>
                                <Button className='m-auto btn1'
                                    disabled={!checked}
                                    onClick={() => handleSubsSucess()}
                                >
                                    {preBookText ? "Pre-Book" : "Subscribe Now"}
                                </Button>
                            </div>

                        }
                    </div>
                </Col> : null}
            </Row >

            {
                popUpOverTextEligible &&
                <InfoPopup
                    showPopUpText={showPopUpTextEligible}
                    toggleInfoPopup={clickNext}
                    text={popUpOverTextEligible}
                    img={ipoLimit}
                />
            }
            <UpiLimitPopup
                showUpiLimit={showUpiLimit}
                toggleUpiLimitPopup={toggleUpiLimitPopup}
                img={ipoLimit}
            />
            {
                popUpOverText &&
                <OfflinePopUp
                    excedeImg={limitExcede}
                    showPopUpText={showPopUpTextMore}
                    toggleInfoPopup={clickNext}
                    text={popUpOverText}
                    button={'here'}
                    handleProceedOffline={handleProceedOffline}
                />
            }
            {
                showTotalBids &&
                <InfoTablePopUp
                    showPopUpText={showTotalBids}
                    toggleInfoPopup={handleShowTable}
                    selectedItems={selectedItems}
                    inputValues={inputValues}
                    totalAmount={totalAmount}
                    isMobile={props?.isMobile}
                />
            }
            {
                showUpiTable &&
                <UpiInfoTable
                    showPopUpText={showUpiTable}
                    toggleInfoPopup={handleShowUpiList}
                    upiList={props?.staticContent?.ipo.IPO_UPI_HANDLES}
                />
            }
            {
                showThankYou &&
                <SubsSucess
                    showThankYou={showThankYou}
                    toggleThankYou={toggleThankYou}
                    preBookText={preBookText}
                    appNo={appNo}
                    email={email}
                    totalAmount={totalAmount}
                />
            }
            <ToastContainer />
        </>
    )
}

export default FirstFoldIpo